"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  NEW_FAQ_TOPIC_SELECTED: 'NEW_FAQ_TOPIC_SELECTED'
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/constants/memberFaqUIActionKeys.js
// module id = 4398
// module chunks = 9